module.exports = __webpack_public_path__ + "img/prizeInfo.3e950d2a.png";